import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const ChromaticPolynomialModule = () => (
  <DMModuleSubtopic
    title="Chromatic Polynomial"
    videos={[
      "https://www.youtube.com/embed/_aRaskIl2ok",
      "https://www.youtube.com/embed/B23E3kZ8mB4",
      "https://www.youtube.com/embed/CHscTB344BM"
    ]}
    takeaways={[
      
      {text:"A chromatic partition divides the vertices of a graph into sets where each set contains all the vertices of one colour, and no two adjacent vertices are placed in the same colour set."},
      {text:"Every planar graph can be coloured using at most four colours so that no two adjacent vertices share the same colour."},
      {
        text:"Theorem",
        image:"/dm_66.png"
      }
    ]}
    questions={[
        {image:"/dm_67.png"},
        {image:"/dm_68.png"},
        {image:"/dm_69.png"},
        {image:"/dm_70.png"},
        {image:"/dm_71.png"},
        {image:"/dm_72.png"},
    ]}
    exampleVideos={[]}
  />
);

export default ChromaticPolynomialModule;
